import { useState } from 'react'

/**
 * One nullable payload per modal. Booleans alongside the payloads let two modals be open at
 * once and made `existsOnAnotherPlatform` a slot two of them wrote to, so opening one moved
 * data the other read.
 */
export interface ISignupModalsState {
  domainPlatform: string | null
}

export interface ISignupModals {
  state: ISignupModalsState
  showSignupWithAnotherPlatform: (domainPlatform: string) => void
  hideSignupWithAnotherPlatform: () => void
}

/**
 * Every modal on the page in one place, so the sign-up flows can open one without knowing
 * how it is rendered.
 */
export const useSignupModals = (): ISignupModals => {
  const [domainPlatform, setDomainPlatform] = useState<string | null>(null)

  return {
    state: { domainPlatform },
    showSignupWithAnotherPlatform: setDomainPlatform,
    hideSignupWithAnotherPlatform: () => setDomainPlatform(null),
  }
}
